import { useCallback, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import iconSuccess from '../../assets/images/automatedTrafficFineNotificationSuccess.png'
import { PAYMENT_SUCCESS } from '../../constants/payment'
import { PATH } from '../../constants/router'
import { getUrlParamValue } from '../../helper/params'
import appUserService from '../../services/appUserService'
import { IS_TAX_CDS_MODE } from '../../constants/appMode'
import './index.scss'

export default function AutoTrafficFineNotificationPaymentSuccess() {
  const history = useHistory()
  const isRedirectingRef = useRef(false)

  const handleRedirect = useCallback(
    (orderId) => {
      if (isRedirectingRef.current) return

      isRedirectingRef.current = true

      if (orderId) {
        const successPath = PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS.replace(':id', orderId)
        history.replace(`${successPath}?orderIdSuccess=${orderId}`)
        return
      }

      history.replace(IS_TAX_CDS_MODE ? PATH.TAX_CDS_SMART_ASSISTANT : PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SERVICES)
    },
    [history]
  )

  useEffect(() => {
    const rawOrderIdSuccess = getUrlParamValue('orderIdSuccess')
    const orderId = Number(rawOrderIdSuccess)

    if (!rawOrderIdSuccess || Number.isNaN(orderId)) {
      const timeout = setTimeout(() => {
        handleRedirect()
      }, 3000)

      return () => clearTimeout(timeout)
    }

    const startTime = Date.now()
    let pollingInterval = null
    let maxTimeout = null

    const checkPaymentStatus = async () => {
      try {
        const result = await appUserService.getOrderDetail({ id: orderId })
        const { statusCode, data } = result || {}

        if (statusCode === 200 && data?.paymentStatus === PAYMENT_SUCCESS) {
          clearInterval(pollingInterval)
          clearTimeout(maxTimeout)

          const elapsedTime = Date.now() - startTime

          if (elapsedTime < 3000) {
            setTimeout(() => {
              handleRedirect(orderId)
            }, 3000 - elapsedTime)
          } else {
            handleRedirect(orderId)
          }
        }
      } catch (error) {}
    }

    checkPaymentStatus()
    pollingInterval = setInterval(checkPaymentStatus, 1000)

    maxTimeout = setTimeout(() => {
      clearInterval(pollingInterval)
      handleRedirect(orderId)
    }, 12000)

    return () => {
      clearInterval(pollingInterval)
      clearTimeout(maxTimeout)
    }
  }, [handleRedirect])

  return (
    <LayoutPartner>
      <div className="AutoTrafficFineNotificationPaymentSuccess">
        <div className="AutoTrafficFineNotificationPaymentSuccess_icon">
          <img src={iconSuccess} alt="" />
        </div>

        <div className="AutoTrafficFineNotificationPaymentSuccess_title">Thanh toán thành công</div>

        <div className="AutoTrafficFineNotificationPaymentSuccess_description">
          Hệ thống đang xác nhận đơn hàng, bạn sẽ được chuyển hướng trong giây lát...
        </div>
      </div>
    </LayoutPartner>
  )
}